module.exports = __webpack_public_path__ + "img/feature-1.e1b0ed18.png";